<template>
  <login-shell>
    <div class="signin-form">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="min-height-5"></div>
      <div class="reset-title">
        <label>{{`${screenType} Password`}}</label>
      </div>
      <form action>
        <div>
          <p class="label">Enter New Password</p>
          <div class="password">
            <input
              class="input-field"
              id="email"
              name="New Password"
              :type="passwordtype1"
              maxlength="12"
              v-validate="{required:true, regex:confirmPassword,}"
              v-model="formData.newPassword"
            />
            <i class="material-icons pointer" v-on:click="toggleimg()" md-18 md-inactive>{{icon1}}</i>
          </div>
          <span
            class="errorMessage"
            v-show="errors.has('New Password')"
          >{{ errors.first('New Password') }}</span>
          <br />
          <p class="label">Confirm Password</p>
          <div class="password">
            <input
              class="input-field"
              :type="passwordtype2"
              name="Confirm Password"
              maxlength="12"
              v-validate="{required:true,  regex:confirmPassword}"
              v-model="formData.confirmedPassword"
            />
            <i class="material-icons pointer" v-on:click="toggleimg2()" md-18 md-inactive>{{icon2}}</i>
          </div>
          <span
            class="errorMessage"
            v-show="errors.has('Confirm Password')"
          >{{ errors.first('Confirm Password') }}</span>
        </div>

        <button type="button" class="signin-btn" @click="reGeneratePassword()">Submit</button>
      </form>

      <p class="passwordInfo">
        <img class="" src="@/assets/info-2.svg" alt />Password must have at least one uppercase letter, one lowercase letter, one
        number, one special character and length should be 8 to 12
      </p>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Your Password has been reset successfully.`"
        btnText="OK"
        @back="ok"
      ></pop-up-message>
    </div>
  </login-shell>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import LoginShell from "./loginShell.vue";
import * as config from "@/apis/config.js";

export default {
  name: "setResetPassword",
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  components: {
    LoginShell
  },
  data() {
    return {
      confirmPassword:null,
      screenType: "Reset",
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      passwordtype1: "password",
      passwordtype2: "password",
      icon1: "visibility_off",
      icon2: "visibility_off",
      formData: {
        newPassword: "",
        confirmedPassword: ""
      }
    };
  },
  mounted() {
    this.decryptToken();
  },

  activated() {
    this.decryptToken();
  },

  methods: {
    ...mapActions({
      resetPassword: "auth/generatePassword"
    }),

    decryptToken() {
      try {
        this.confirmPassword = config.Regex.PASSWORD;
        let currentToken = this.getToken();
        let base64Url = currentToken.split(".")[1];
        let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        let jsonPayload = atob(base64);
        let obj = JSON.parse(jsonPayload);

        if (obj.type == "SETPASSWORD") {
          this.screenType = "Set";
        } else {
          this.screenType = "Reset";
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    getToken() {
      try {
        return this.$route.query.token;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },
    toggleimg() {
      try {
        if (this.passwordtype1 == "password") {
          this.passwordtype1 = "text";
          this.icon1 = "visibility";
        } else {
          this.passwordtype1 = "password";
          this.icon1 = "visibility_off";
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },
    toggleimg2() {
      try {
        if (this.passwordtype2 == "password") {
          this.passwordtype2 = "text";
          this.icon2 = "visibility";
        } else {
          this.passwordtype2 = "password";
          this.icon2 = "visibility_off";
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },
    reGeneratePassword() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.formData.newPassword == this.formData.confirmedPassword) {
              this.confirmResetPassword();
            } else {
              this.toast = true;
              this.errmsg = "Password and Confirm Password should be same";
            }
          } else {
            this.toast = true;
            this.errmsg = "Please enter valid Password";
          }
        });
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    ok() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: "/signin"
      });
    },

    async confirmResetPassword() {
      try {
        let obj = {
          data: {
            password: this.formData.newPassword,
            confirm_password: this.formData.confirmedPassword
          },
          token: this.$route.query.token
        };
        let data = await this.resetPassword(obj);
        if (data.status) {
          this.showSuccessMsg = true;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.signin-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.signin-form form {
  padding: 10px 40px 25px;
}

.reset-title {
  text-align: center;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.label {
  height: 15px; // margin-top: 25px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 13px;
  color: #0e0e0e;
}

.signin-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 6px;
  padding: 10px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
}

.signin-btn {
  margin-top: 50px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

.passwordInfo{
  padding: 0 40px 20px;
}

.passwordInfo > img{
  height: 15px;
  width: 15px;
  margin-right: 5px;
}


/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 275px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: 14px;
    margin-bottom: auto;
  }

  .effDateClass {
    margin-bottom: 5%;
  }
  .popup-btns {
    margin-top: 10%;
    display: flex;
    justify-content: space-between;
    a {
      margin-top: 4%;
      margin-left: 32%;
    }
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media only screen and (max-width: 600px) {
  .signin-form form {
    padding: 16px 20px 25px;
  }
}
.password {
  display: flex;
  i {
    margin-left: -30px;
    margin-top: 10px;
  }
}
.pointer {
  cursor: pointer;
}
.min-height-5 {
  min-height: 5px;
}
</style>